export default __webpack_public_path__ + "static/ba-right-old-9d1ebf9c30b46cbeef522f523b41e2db.webp";